<template>
  <div class="animated fadeIn">
    <form>
      <b-row>
        <b-col sm="12">
          <b-card
            id="card-relatorio-operacao-venda"
            :bg-variant="isDark ? 'dark' : 'white'"
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
            <div class="p-4 d-flex align-items-center justify-content-between" :class="isDark ? 'bg-secondary-soft' : 'bg-primary-soft'">
              <div>
                <h4 class="mb-1 font-weight-bold" :class="isDark ? 'text-white' : 'text-primary'">
                  <i class="fa fa-line-chart mr-2"></i>Relatorio Operacional de Vendas
                </h4>
                <span class="text-muted d-block">Pedidos operacionais por data do pedido, abertos e fechados, exceto cancelados.</span>
              </div>
            </div>

            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-list-alt mr-2"></i>Tipo de Relatorio</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Modelo">
                    <b-form-select
                      v-model="tipoRelatorio"
                      :options="opcoesRelatorio"
                      :plain="true"
                      class="form-control-lg"
                      :class="isDark ? 'bg-secondary text-white border-info' : 'select-premium'"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-users mr-2"></i>Pessoas</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Cliente">
                    <cliente-pesquisa
                      @retornaId="filtros.clienteId = $event"
                      :idInicial="filtros.clienteId"
                      label=""
                      place="Todos os clientes"
                      labelBotao=""
                      ref="clientePesquisa"
                      idModal="clienteOperacaoVendaModal">
                    </cliente-pesquisa>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Vendedor">
                    <vendedor-dropdown
                      v-model="filtros.vendedorId"
                      ref="vendedorPesquisa"
                      placeholder="Todos os vendedores"
                      :disabled="isVendedor"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-cubes mr-2"></i>Produtos</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Produto">
                    <produto-pesquisa
                      @retornaId="filtros.produtoId = $event"
                      :idInicial="filtros.produtoId"
                      label=""
                      place="Todos os produtos"
                      labelBotao=""
                      ref="produtoPesquisa">
                    </produto-pesquisa>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Grupo de Produto">
                    <grupo-produto-drop-down
                      v-model="filtros.grupoProdutoId"
                      ref="grupoProdutoPesquisa"
                      placeholder="Todos os grupos"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="section-container mb-2" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-calendar mr-2"></i>Periodo</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Data Inicio">
                    <cec-input-data id="operacaoVendaDt1" v-model="filtros.dt1" :state="filtros.dt1 ? null : false" />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Data Fim">
                    <cec-input-data id="operacaoVendaDt2" v-model="filtros.dt2" :state="filtros.dt2 ? null : false" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="card-footer-action p-4 text-center mt-2" :class="isDark ? 'bg-dark-darker' : 'bg-white'">
              <b-button size="lg" type="button" variant="primary" @click.stop.prevent="gerarRelatorio()" class="px-5 py-3 btn-pill shadow-lg btn-generate">
                <i class="fa fa-print mr-2"></i> GERAR RELATORIO OPERACIONAL
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import moment from 'moment'
import ClientePesquisa from '../pesquisa/ClientePesquisa.vue'
import ProdutoPesquisa from '../pesquisa/ProdutoPesquisa.vue'
import VendedorDropdown from '../componentes/dropdown/VendedorDropdown.vue'
import GrupoProdutoDropDown from '../componentes/dropdown/GrupoProdutoDropDown.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import Tools from '@/tools/tools.js'
import { printGroupedHtmlReport } from '@/utils/RelatorioHTML.js'

export default {
  components: {
    ClientePesquisa,
    ProdutoPesquisa,
    VendedorDropdown,
    GrupoProdutoDropDown,
    CecInputData
  },
  data () {
    return {
      tipoRelatorio: 'CONSOLIDADO_PRODUTO',
      filtros: {
        clienteId: null,
        vendedorId: null,
        produtoId: null,
        grupoProdutoId: null,
        dt1: moment().format('YYYY-MM-DD'),
        dt2: moment().format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    isDark () {
      return this.$store.getters['tema/IS_DARK']
    },
    isVendedor () {
      return !((localStorage.getItem('vendedorId') === undefined) || (localStorage.getItem('vendedorId') === '100') || (localStorage.getItem('vendedorId') === null))
    },
    isValid () {
      return !!this.filtros.dt1 && !!this.filtros.dt2
    },
    tipoSelecionado () {
      return this.opcoesRelatorio.find(o => o.value === this.tipoRelatorio) || {}
    },
    opcoesRelatorio () {
      return [
        { value: 'CONSOLIDADO_PRODUTO', text: 'Consolidado por Produto' },
        { value: 'PEDIDOS_OPERACAO', text: 'Pedidos da Operacao' },
        { value: 'CONSOLIDADO_PRODUTO_SEM_LUCRO', text: 'Consolidado por Produto sem Lucro' },
        { value: 'PEDIDOS_OPERACAO_SEM_LUCRO', text: 'Pedidos da Operacao sem Lucro' }
      ]
    }
  },
  methods: {
    getLabelFromDropDown (refName, value) {
      if (!value) return ''
      const component = this.$refs[refName]
      if (component && component.options) {
        const option = component.options.find(o => String(o.value) === String(value))
        return option ? option.text : ''
      }
      return ''
    },
    fmtDate (value) {
      return value ? moment(value).format('DD/MM/YYYY') : ''
    },
    fmtNumber (value, digits = 2) {
      return Number(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: digits, maximumFractionDigits: digits })
    },
    fmtCurrency (value) {
      return this.fmtNumber(value, 2)
    },
    getParams () {
      return {
        dt1: this.filtros.dt1,
        dt2: this.filtros.dt2,
        clienteId: this.filtros.clienteId || '',
        vendedorId: this.filtros.vendedorId || '',
        produtoId: this.filtros.produtoId || '',
        grupoProdutoId: this.filtros.grupoProdutoId || '',
        tipoRelatorio: this.tipoRelatorio,
        lbCliente: this.$refs.clientePesquisa?.$refs?.auto?.display || '',
        lbVendedor: this.getLabelFromDropDown('vendedorPesquisa', this.filtros.vendedorId),
        lbProduto: this.$refs.produtoPesquisa?.$refs?.auto?.display || '',
        lbGrupoProduto: this.getLabelFromDropDown('grupoProdutoPesquisa', this.filtros.grupoProdutoId),
        lbUsuario: window.localStorage.getItem('nomeusuario') || ''
      }
    },
    getObservacoes (dados) {
      const filtros = dados.filtros || {}
      const linhas = [
        `Periodo: ${this.fmtDate(filtros.dt1)} a ${this.fmtDate(filtros.dt2)}`,
        'Tipo de Data: Data do Pedido',
        filtros.cliente ? `Cliente: ${filtros.cliente}` : '',
        filtros.vendedor ? `Vendedor: ${filtros.vendedor}` : '',
        filtros.produto ? `Produto: ${filtros.produto}` : '',
        filtros.grupoProduto ? `Grupo de Produto: ${filtros.grupoProduto}` : '',
        filtros.situacao ? `Situacao: ${filtros.situacao}` : ''
      ]
      return linhas.filter(Boolean).join('\n')
    },
    percentualLucroResumo (rows) {
      const total = rows.reduce((sum, row) => sum + (Number(row.VL_TOTAL) || 0), 0)
      const lucro = rows.reduce((sum, row) => sum + (Number(row.VL_LUCRO) || 0), 0)
      return total !== 0 ? (lucro / total) * 100 : 0
    },
    isPedidosOperacao () {
      return this.tipoRelatorio === 'PEDIDOS_OPERACAO' || this.tipoRelatorio === 'PEDIDOS_OPERACAO_SEM_LUCRO'
    },
    isSemLucro () {
      return this.tipoRelatorio === 'CONSOLIDADO_PRODUTO_SEM_LUCRO' || this.tipoRelatorio === 'PEDIDOS_OPERACAO_SEM_LUCRO'
    },
    getColumns () {
      const number = (digits = 2) => (value) => this.fmtNumber(value, digits)
      const currency = (value) => this.fmtCurrency(value)
      const date = (value) => this.fmtDate(value)
      const percentual = (value) => `${this.fmtNumber(value, 2)}%`
      const percentualSummary = (rows) => this.percentualLucroResumo(rows)

      if (this.isPedidosOperacao()) {
        const columns = [
          { key: 'PEDIDO_ID', label: 'Pedido', type: 'number', formatter: number(0), width: '6%' },
          { key: 'DT_PEDIDO', label: 'Dt. Pedido', type: 'date', formatter: date, width: '7%' },
          { key: 'DT_SAIDA', label: 'Dt. Venda', type: 'date', formatter: date, width: '7%' },
          { key: 'CLIENTE_ID', label: 'Cod. Cliente', type: 'number', formatter: number(0), width: '6%' },
          { key: 'NOME_CLIENTE', label: 'Cliente', width: '20%' },
          { key: 'NOME_VENDEDOR', label: 'Vendedor', width: '14%' },
          { key: 'SITUACAO_DESCRICAO', label: 'Situacao', width: '11%' },
          { key: 'QT_ITENS', label: 'Itens', type: 'number', formatter: number(0), width: '5%' },
          { key: 'PECAS_CONSOLIDADAS', label: 'Volumes', type: 'number', formatter: number(0), width: '6%' },
          { key: 'QUANT_CONSOLIDADA', label: 'Quantidade', type: 'number', formatter: number(2), width: '7%' },
          { key: 'VL_TOTAL', label: 'Total (R$)', type: 'currency', formatter: currency, width: '8%' }
        ]

        if (!this.isSemLucro()) {
          columns.push(
            { key: 'VL_LUCRO', label: 'Lucro (R$)', type: 'currency', formatter: currency, width: '8%' },
            { key: 'PC_LUCRO', label: '% Lucro', type: 'number', formatter: percentual, summary: percentualSummary, width: '6%' }
          )
        }

        return columns
      }

      const columns = [
        { key: 'PRODUTO_ID', label: 'Cod. Produto', type: 'number', formatter: number(0), width: '8%' },
        { key: 'NOME_PRODUTO', label: 'Produto', width: '29%' },
        { key: 'NOME_GRUPO', label: 'Grupo', width: '18%' },
        { key: 'QT_PEDIDOS', label: 'Pedidos', type: 'number', formatter: number(0), width: '7%' },
        { key: 'PECAS_CONSOLIDADAS', label: 'Volumes', type: 'number', formatter: number(0), width: '7%' },
        { key: 'QUANT_CONSOLIDADA', label: 'Quantidade', type: 'number', formatter: number(2), width: '9%' },
        { key: 'VL_TOTAL', label: 'Total (R$)', type: 'currency', formatter: currency, width: '10%' }
      ]

      if (!this.isSemLucro()) {
        columns.push(
          { key: 'VL_CUSTO_TOTAL', label: 'Custo (R$)', type: 'currency', formatter: currency, width: '10%' },
          { key: 'VL_LUCRO', label: 'Lucro (R$)', type: 'currency', formatter: currency, width: '10%' },
          { key: 'PC_LUCRO', label: '% Lucro', type: 'number', formatter: percentual, summary: percentualSummary, width: '7%' }
        )
      }

      return columns
    },
    getGroupBy () {
      if (this.isPedidosOperacao()) {
        return { key: 'DT_PEDIDO', formatter: value => `Data do Pedido: ${this.fmtDate(value)}` }
      }
      return { key: 'NOME_GRUPO' }
    },
    getSumKeys () {
      if (this.isPedidosOperacao()) {
        if (this.isSemLucro()) {
          return ['QT_ITENS', 'PECAS_CONSOLIDADAS', 'QUANT_CONSOLIDADA', 'VL_TOTAL']
        }
        return ['QT_ITENS', 'PECAS_CONSOLIDADAS', 'QUANT_CONSOLIDADA', 'VL_TOTAL', 'VL_LUCRO', 'PC_LUCRO']
      }

      if (this.isSemLucro()) {
        return ['QT_PEDIDOS', 'PECAS_CONSOLIDADAS', 'QUANT_CONSOLIDADA', 'VL_TOTAL']
      }

      return ['QT_PEDIDOS', 'PECAS_CONSOLIDADAS', 'QUANT_CONSOLIDADA', 'VL_TOTAL', 'VL_CUSTO_TOTAL', 'VL_LUCRO', 'PC_LUCRO']
    },
    gerarHtml (dados) {
      printGroupedHtmlReport({
        rows: dados.linhas || [],
        columns: this.getColumns(),
        groupBy: this.getGroupBy(),
        sumKeys: this.getSumKeys(),
        systemName: dados.empresa?.FANTASIA || window.localStorage.getItem('nomeempresa') || '',
        reportTitle: `Relatorio Operacional de Vendas - ${this.tipoSelecionado.text}`,
        printedBy: window.localStorage.getItem('nomeusuario') || '',
        observations: this.getObservacoes(dados),
        landscape: true,
        autoPrint: true
      })
    },
    gerarRelatorio () {
      if (!this.isValid) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o periodo do relatorio')
        return
      }

      this.$store.commit('controle/setAguardando', true)
      const uri = '/api/protected/relatorios/operacao-venda?' + new URLSearchParams(this.getParams()).toString()
      this.$http.get(uri)
        .then(response => {
          const dados = response.data || {}
          if (!dados.linhas || dados.linhas.length === 0) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'info', 'Nenhuma informacao para o filtro selecionado')
            return
          }
          this.gerarHtml(dados)
        })
        .catch((err) => {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', err || 'Ocorreram erros ao gerar o relatorio')
        })
        .finally(() => {
          this.$store.commit('controle/setAguardando', false)
        })
    }
  },
  created () {
    if (this.isVendedor) {
      this.filtros.vendedorId = localStorage.getItem('vendedorId')
    }
  }
}
</script>

<style scoped>
.bg-primary-soft { background-color: rgba(32, 168, 216, 0.1); }
.bg-secondary-soft { background-color: rgba(108, 117, 125, 0.1); }
.bg-dark-darker { background-color: #1e2225; }

.section-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e4e7ea;
  transition: all 0.3s ease;
}

.section-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.section-container.dark-mode {
  background: #2f353a;
  border-color: #434a50;
}

.section-title {
  color: #20a8d8;
  border-bottom: 1px solid #c2cfd6;
  padding-bottom: 8px;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 1px;
}

.section-title.dark-mode {
  color: #63c2de;
  border-color: #434a50;
}

.btn-generate {
  font-weight: 700;
  letter-spacing: 1px;
  padding: 12px;
  transition: all 0.3s;
}

.btn-generate:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(32, 168, 216, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/views/relatorios/RelOperacaoVenda.vue